import { MenuEntry } from '@src/menu-entry';
import clickAndCollect from '@src/click-and-collect/menu';

export default [
    MenuEntry.create()
        .setRoute('pos_stock_taking_ldn'),
    MenuEntry.create()
        .setRoute('one_bin_warehouse_filter_overview')
        .setAdditionalRoutes([
            'one_bin_warehouse_filter_create',
            'one_bin_warehouse_filter_edit',
        ]),
    MenuEntry.create()
        .setRoute('pos_express_pick'),
    MenuEntry.create()
        .setRoute('one_bin_warehouse_pick_list'),
    MenuEntry.create()
        .setRoute('pick_one_bin_warehouse_not_found_list'),
    MenuEntry.create()
        .setRoute('settings_warehouse_users_warehouses_overview'),
    MenuEntry.create()
        .setRoute('pos_refill_recommendation_list'),
    MenuEntry.create()
        .setRoute('pos_print_price_label'),
    MenuEntry.create()
        .setRoute('pos_print_bike_label'),
    MenuEntry.create()
        .setRoute('pos_printed_price_diff'),
    ...clickAndCollect,
];
